import { memo, useEffect, useState } from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getJobCategoryMapping } from '../_api';
import DetailEntry from '../layouts/DetailEntry';
import DetailLayout from '../layouts/DetailLayout';
import JobCategoryDetails from '../JobCategory/DetailsView';

/**
 * Epic Job Category Mapping search results view
 * @param {any} id - primary key to identify the job category mapping
 * @returns job category mapping search result details
 */
const DetailsView = memo(function JobCategoryMappingDetails({
	id,
	enableLinks = false,
}) {
	const [sShowJobCategories, setShowJobCategories] = useState(false);
	const [sJobCategoryMapping, setJobCategoryMapping] = useState(null);
	const [sErrorMessage, setErrorMessage] = useState(null);

	/**
	 * trigger API call to get job category mapping details upon page render
	 */
	useEffect(() => {
		let active = true;

		async function fetchApi() {
			try {
				const selectedJobCategoryMapping = await getJobCategoryMapping(
					id
				);
				setJobCategoryMapping(selectedJobCategoryMapping);
			} catch {
				setErrorMessage(
					'Encountered error when trying to fetch information on Job Category Mapping ID = "' +
						id +
						'"'
				);
			}
		}

		if (active) {
			fetchApi();
		}

		return () => {
			active = false;
		};
	}, [id]);

	/**
	 * Toggle job category mapping section visibility
	 * @param {boolean} expand
	 */
	const onExpandJobCategoriesHandler = async expand => {
		setShowJobCategories(expand);
	};

	return (
		<>
			{sErrorMessage && (
				<Alert
					severity='error'
					variant='filled'
					onClose={() => {
						setErrorMessage(null);
					}}
				>
					{sErrorMessage}
				</Alert>
			)}
			{sJobCategoryMapping?.jobCategoryID && (
				<DetailLayout>
					<DetailEntry
						label={'Department Name'}
						value={
							!!sJobCategoryMapping?.department
								? sJobCategoryMapping?.department
								: 'N/A'
						}
					/>
					<DetailEntry
						label={'Job Title'}
						value={
							!!sJobCategoryMapping?.jobTitle
								? sJobCategoryMapping?.jobTitle
								: 'N/A'
						}
					/>
					<>
						<Box
							display='flex'
							justifyContent='space-between'
							alignItems='center'
						>
							<DetailEntry
								label={'Associated Job Categories'}
								disableLoading
							/>

							<IconButton
								onClick={() =>
									onExpandJobCategoriesHandler(
										!sShowJobCategories
									)
								}
							>
								<ExpandMoreIcon />
							</IconButton>
						</Box>
						{sShowJobCategories && (
							<>
								<JobCategoryDetails
									id={sJobCategoryMapping.jobCategoryID}
									hideJobCategories
									enableLinks={enableLinks}
								/>
							</>
						)}
					</>
				</DetailLayout>
			)}
		</>
	);
});

export default DetailsView;
